import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

interface ICheckCodeAvailabilityParams {
  profilingCode: IProfilingCode
  userEmail: string
  userRoles: string[]
}

export const checkCodeAvailability = ({
  profilingCode,
  userEmail,
  userRoles,
}: ICheckCodeAvailabilityParams) => {
  const hasRoles = profilingCode.roles.some((role) => userRoles.includes(role))
  const hasUsers = profilingCode.users.includes(userEmail)

  return hasRoles || hasUsers
}
